import { render, staticRenderFns } from "./IndustryTrends.vue?vue&type=template&id=10a57276&scoped=true"
import script from "./IndustryTrends.vue?vue&type=script&lang=js"
export * from "./IndustryTrends.vue?vue&type=script&lang=js"
import style0 from "./IndustryTrends.vue?vue&type=style&index=0&id=10a57276&prod&lang=scss"
import style1 from "./IndustryTrends.vue?vue&type=style&index=1&id=10a57276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a57276",
  null
  
)

export default component.exports